import React, { useMemo } from "react";
import KC_Heading1 from "../../../../designsystem/typography/KC-Heading/KC_Heading1";
import KC_Button, {
  KC_ButtonSize
} from "../../../../designsystem/KC_Button/KC_Button";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import KC_Separator from "../../../../designsystem/KC_Separator/KC_Separator";
import { useHistory } from "react-router-dom";
import { MONTHLY_STATS_DETAIL } from "../../../../utils/routes/routes";
import TSUtils from "../../../../utils/helpers/TSUtils";
import moment from "moment";
import useMonthlyStatisticsData from "../../../../utils/hooks/useMonthlyStatisticsData";
import { tt } from "../../../../utils/i18n/i18n";
import { FullScreenLoader } from "../../../../components/Loaders/FullScreenLoader/FullScreenLoader";
import TwemojiWrapper from "../../../../components/TwemojiWrapper/TwemojiWrapper";
import KC_UIText from "../../../../designsystem/typography/KC_UIText/KC_UIText";
import { buildPathWithTrackingId } from "../../../../utils/routing/routingUtils";
import { useAccountToDisplaySelector } from "../../../../redux/actions/user";
import { ManagedAccountDropdown } from "../../../../components/ManagedAccountDropdown/ManagedAccountDropdown";

export default function MonthlyStats() {
  const history = useHistory();
  const { accountToDisplay } = useAccountToDisplaySelector();

  const handleClick = (month: number, year: number) => {
    history.push(
      buildPathWithTrackingId(
        `${MONTHLY_STATS_DETAIL}?month=${month}&year=${year}`,
        accountToDisplay?.trackingID
      )
    );
  };

  const { sts, ets, isLoading } = useMonthlyStatisticsData();

  const monthYearList = useMemo(() => {
    if (!sts || !ets) {
      return [];
    }
    return TSUtils.getMonthsYearBetween(sts, ets, false).reverse();
  }, [sts, ets]);

  if (isLoading) {
    return <FullScreenLoader loading={true} />;
  }

  return (
    <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center overflow-auto px-4 dashboard-v2">
      <div className="d-flex flex-row align-items-center justify-content-center mb-4">
        <ManagedAccountDropdown />
      </div>
      <KC_Heading1
        text={tt("monthly_performance_reports")}
        className="text-center"
      />
      <KC_Separator />
      <div className="w-100 d-flex st-gap flex-column align-items-center">
        {!monthYearList?.length && (
          <div className="d-flex flex-column align-items-center st-gap">
            <TwemojiWrapper isVeryBigText={true}>🤖</TwemojiWrapper>
            <KC_UIText
              weight="reg"
              className="d-none d-sm-block w-50 text-center"
              text={tt("monthly_stats_no_players")}
            />
            <KC_UIText
              weight="reg"
              className="d-block d-sm-none w-100 text-center"
              text={tt("monthly_stats_no_players")}
            />
          </div>
        )}
        {!!monthYearList?.length &&
          monthYearList?.map(({ sts, ets, month, year }) => {
            const date_text = `${TSUtils.capitalizeFirstLetter(moment(sts, "X").format(tt("date_format_month_only")))} ${year}`;
            return (
              <KC_Button
                isPrimary={false}
                isTransparent={true}
                size={KC_ButtonSize.Giant}
                className="d-flex border"
                extraStyle={{ width: 200 }}
                text={date_text}
                showIconOnTheRight={true}
                icon={faArrowRight}
                onClick={() => handleClick(month, year)}
              />
            );
          })}
      </div>
    </div>
  );
}
